import { API_BASE_URL, getBaseHeaders } from './api.config';
import { throwApiError } from './api.error';

export interface CreateIllegalContentNoticeRequest {
  reporterName: string;
  reporterEmail: string;
  identityOmitted: boolean;
  contentUrl: string;
  explanation: string;
  goodFaithConfirmed: boolean;
  website: string;
}

export interface IllegalContentNoticeReceipt {
  referenceCode: string;
  submittedAt: string;
}

export const submitIllegalContentNotice = async (
  request: CreateIllegalContentNoticeRequest
): Promise<IllegalContentNoticeReceipt> => {
  const response = await fetch(`${API_BASE_URL}/illegal-content-notices`, {
    method: 'POST',
    headers: {
      ...getBaseHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) await throwApiError(response);
  return await response.json();
};
